module.exports = __webpack_public_path__ + "img/appBarMovile.5e261353.png";